var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44275 0.749376C8.44275 0.940376 8.36975 1.13238 8.22375 1.27838L4.75375 4.76538C4.61275 4.90638 4.42175 4.98538 4.22175 4.98538C4.02275 4.98538 3.83175 4.90638 3.69075 4.76538L0.218751 1.27838C-0.0732494 0.985376 -0.0732494 0.511376 0.220751 0.218376C0.514751 -0.0736236 0.989751 -0.0726236 1.28175 0.220376L4.22175 3.17338L7.16175 0.220376C7.45375 -0.0726236 7.92775 -0.0736236 8.22175 0.218376C8.36975 0.364376 8.44275 0.557376 8.44275 0.749376Z",
    fill: "#0A74DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropExport);
export default __webpack_public_path__ + "static/media/drop-export.3fcb9c583e8052369f83dc914e252d76.svg";
export { ForwardRef as ReactComponent };